import { render, staticRenderFns } from "./startFirma.vue?vue&type=template&id=3eac18b8&"
import script from "./startFirma.vue?vue&type=script&lang=js&"
export * from "./startFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports